import styled from 'styled-components';
import colors from '../../../../../../../../../styles/colors';

const InfoSection = styled.section`
  padding: 18px;
  border-radius: 12px;
  margin-bottom: 10px;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  align-items: flex-start;
  gap: 15px;
`;

const InfoLabel = styled.div`
  font-size: 15px;
  width: fit-content;
  color: ${colors.shades.gamma10};
  ${({ $marginTop }) => $marginTop && `margin-top: ${$marginTop}px;`}
`;

const InfoValue = styled.div`
  width: 100%;
  flex: 1;
  word-break: break-word;
  font-size: 14px;
  border-bottom: 1px solid ${colors.shades.secondary7};
  padding-bottom: 15px;
`;

const PricingTable = styled.table`
  width: 90%;
  border-collapse: collapse;
  margin-top: 4px;
  margin-bottom: 12px;
  font-size: 14px;
  border-radius: 100px;

  tr:nth-child(odd) {
    background: ${colors.base.alpha};
  }

  td:first-child {
    min-width: 170px;
  }
  
  td:nth-child(2) {
    width: 70px;
  }
`;

const PricingTh = styled.th`
  border: 1px solid ${colors.shades.secondary7};
  padding: 10px 8px;
  text-align: left;
  color: ${colors.shades.gamma10};
  background: ${colors.shades.secondary10};
  font-weight: 600;
`;

const PricingTd = styled.td`
  border: 1px solid ${colors.shades.secondary7};
  padding: 10px 8px;
`;

export {
  InfoSection,
  InfoRow,
  InfoLabel,
  InfoValue,
  PricingTable,
  PricingTh,
  PricingTd,
};
